/**
 * @author Akshay Kumar Singh
 * @file CreateUser Modal
 * @flow
 */
import React, { useState, useEffect } from 'react';
import Modal from 'react-responsive-modal';
import Validator from '../../shared/validator'
import AlertModal from './AlertModal';
import { spinnerService } from '../services/spinner.service';
import { CallApi } from '../services/api.service';
import { useHistory } from "react-router-dom";
import CONFIG from '../../configuration/config'
import validator from '../../shared/validator';
import { LABLES, STRINGS } from '../constants/data';

const BulkUploadModal = ({ isBulkUploadModalOpen, closeModal, getUserDataList }) => {

  const history = useHistory()
  const [, forceUpdate] = useState();

  const [state, setState] = useState({
    fileFormData: '',
    fileName: '',
    email: ''
  });

  useEffect(() => {
    Validator.hideMessages();
  }, [])

  /**
   * @description This function hides validation messages and closes create user modal.
   */
  const handleModal = (event) => {
    event.preventDefault();
    Validator.hideMessages();
    closeModal();
  }

  /**
   * @description This function sets value of state variables
   */
  const handleChange = (event) => {
    const { name, value } = event.target;
    setState({
      ...state,
      [name]: value
    });
  }

  /**
   * @description This function uploads bulk user data.
   */
  const onSubmit = (event) => {
    event.preventDefault();
    const { email, fileFormData, fileName } = state;
    if (validator.allValid()) {
      handleModal(event);
      let formData = new FormData();
      formData.append("file", fileFormData);
      formData.append("email", email);
      spinnerService.show(LABLES.Oval, STRINGS.BULKUPLOADLOADERMSG);
      CallApi(LABLES.POST, CONFIG.uploadBulkUser, {}, formData, '', bulkUploadCallback, history);
    } else {
      Validator.showMessages();
      forceUpdate({})
      AlertModal.showAlert(STRINGS.AllFieldRequired);
    }
  }

  /**
 * @description bulkUploadCallback API callback function
 * @param response This is the response structure received from API
 */
  const bulkUploadCallback = (response) => {
    if (response.success) {
      AlertModal.showAlert(response.message);
      getUserDataList();
    }
  }

  /**
  * @description This function handles the FAQ PDF file.
  */
  const handleFile = event => {
    let { files } = event.target;
    let fileData = files[0];
    if (fileData && (fileData.type === 'application/vnd.ms-excel' ||
      fileData.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      fileData.type === 'application/vnd.ms-excel.sheet.macroEnabled.12')) {
      setState({
        ...state,
        fileFormData: fileData,
        fileName: `(${fileData.name})`
      });
    } else {
      setState({
        ...state,
        fileFormData: '',
        fileName: ''
      });
      event.target.value = null
      AlertModal.showAlert('Please upload excel file only.')
    }
  }

  return (
    <Modal open={isBulkUploadModalOpen} onClose={handleModal} center>
      <div className="pop-up-bg" id="create-audit-popup">
        <div className="rqst-accs-popup">
          <div className="create-audit-outer">
            <div className="top-cntnt">
              <h4> {LABLES.BulkUserUpload} </h4>
              <a href="" onClick={handleModal}>
                <img src={require("../../assets/images/cross-icon.png")} alt="cross-icon" />
              </a>
            </div>
          </div>
          <div className="form-cntnt">
            <form action="" onSubmit={onSubmit}>
              <div className="form-row">
                <div className="column-three">
                  <div className="form-group">
                    <label htmlFor="">{LABLES.EmailAddress}</label>
                    <input
                      className={"form-control " + (Validator.message('email', state.email, 'email') ? 'error' : '')}
                      type="text"
                      name="email"
                      onKeyPress={() => Validator.showMessageFor('email')}
                      placeholder='example@niagarawater.com'
                      onChange={handleChange}
                    />
                    <div className='srv-validation-message'>{Validator.message('email', state.email, 'email')}</div>
                    {/* <select
                      className={"form-control " + (Validator.message('role', state.role, 'role') ? 'error' : '')}
                      onChange={handleChange} defaultValue='' name='role'
                      style={{ textTransform: 'capitalize' }}
                      onKeyPress={() => Validator.showMessageFor('role')}>
                      <option hidden value=''>{STRINGS.SelectRole}</option>
                      {state.roleArr.map((data, index) => {
                        return (
                          <option key={data.id} value={data.value}>
                            {data.value}
                          </option>
                        )
                      })}
                    </select>
                    <div className='srv-validation-message'>{Validator.message('role', state.role, 'role')}</div> */}
                  </div>
                </div>
                <div className="column-three">
                  <div className="form-group">
                    <label htmlFor="">{LABLES.ExcelUpload}</label>
                    <div className="upload-file-control">
                      <input type="file" className={"form-control" + (Validator.message('BulkUploadFile', state.fileName, 'BulkUploadFile') ? 'error' : '')}
                        id="2" name="BulkUploadFile" onChange={handleFile}
                        onKeyPress={() => Validator.showMessageFor('BulkUploadFile')} />
                      <label htmlFor="2">Upload File {state.fileName}</label>
                      <div className='srv-validation-message'>{Validator.message('BulkUploadFile', state.fileName, 'BulkUploadFile')}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="crt-odi-btn-otr">
                <button className="btn-prmry" type="submit" style={{ backgroundColor: '#005daa' }}
                > {LABLES.UploadUserData}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  );
}
export default BulkUploadModal;